var accountSelectors = {
  accountPages: '[data-account-pages]',
  resetPassword : '[data-recover-link]',
  hideResetPass : '[data-hideResetPass]',
  resetPasswordForm : '[data-recover-password-form]',
  loginForm : '[data-login-form] form',
  registerForm: '[data-register-form] form',
  registerFormSubmit: '[data-register-form] form [data-submit]'
};

class accountPages {
  constructor() {
    this.elements = this._getElements();
    if (Object.keys(this.elements).length === 0) return;
    this._setupEventListeners();


    const windowURL = window.location.href;
    const showRecoverForm = windowURL.indexOf('#recover');
    if(showRecoverForm >= 0){
      this.elements.showResetPassword.dispatchEvent(new Event('click'));
    }
    this.elements.loginForm.addEventListener('submit', (e)=>{
      e.preventDefault();
      this._generateCustomerToken(this.elements.loginForm);
    });

    this.elements.registerForm.addEventListener('submit', (event)=>{
      event.preventDefault();
      let _that = event.target;
      let emailField = document.querySelector('#registerCustomerEmail');

      if(emailField.value != '') {
        fetch('https://custom-app.joffreys.com/api/get-customer-detail',{
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({customer_email: emailField.value})
        })
        .then(res => res.json())
        .then(data => {
          if (data.Error) {
            let refBy = _that.closest('form').querySelector('input:checked')?.value || '';
            
            localStorage.setItem("isFirstUser", "true");
            localStorage.setItem("userRefBy", refBy);
            this.elements.registerForm.submit();
            
          } else if(data.message == 'success') {
            let tabLogin = document.querySelector('[data-toggle="tab"][href="#login"]');
            let customerNoticMessageEle = document.querySelector('[data-customer-login-notice]');
            let loginCustomerEmail = document.querySelector('#customerEmail');
            
            customerNoticMessageEle?.classList.remove('d-none');
            tabLogin.click();
            loginCustomerEmail.value = emailField.value;
          }
        })
      } else {
        emailField.setCustomValidity(window.customerDetails.email_required);
        emailField.reportValidity();
        return;
      }
    });

  }



  /**
   * Fecth Selector of login form inputs
   */
  _getElements() {
    const container = document.querySelector(accountSelectors.accountPages);
    return container ? {
      container,
      showResetPassword: document.querySelector(accountSelectors.resetPassword),
      hideResetPass: document.querySelector(accountSelectors.hideResetPass),
      resetPasswordForm: document.querySelector(accountSelectors.resetPasswordForm),
      loginForm: document.querySelector(accountSelectors.loginForm),
      registerForm: document.querySelector(accountSelectors.registerForm),
      registerFormSubmit: document.querySelector(accountSelectors.registerFormSubmit)
    } : {};
  }

  /**
   * Bind Click events on hide/show password field
   */
  _setupEventListeners() {
      this.elements.showResetPassword.addEventListener('click', this._handleResetPassword.bind(this));
      this.elements.hideResetPass.addEventListener('click', this._handleResetPassword.bind(this));
  }
  /**
   * Reset Password
   * @param {event} event 
   */
  _handleResetPassword(event){
      event.preventDefault();
      const _this = event.currentTarget;
      if(_this.classList.contains('hide-resetform')){
        this.elements.loginForm.style.display = 'block';
        this.elements.resetPasswordForm.style.display = 'none';
        if(window.location.href.indexOf("#recover") > -1) {
          window.history.replaceState({ }, '', location.href.replace("#recover", ""));
        }
      }else{
          this.elements.loginForm.style.display = 'none';
          this.elements.resetPasswordForm.style.display = 'block';
      }
  }
  _generateCustomerToken(loginFormElement){
        var email = document.getElementById('customerEmail').value;
        var password = document.getElementById('customerPassword').value;
        const query = `mutation customerAccessTokenCreate($input: CustomerAccessTokenCreateInput!) {
          customerAccessTokenCreate(input: $input) {
              customerUserErrors {
                code
                field
                message
              }
              customerAccessToken {
                accessToken
                expiresAt
              }
          }
        }`;
      
        // Set the body
        var requestBody = JSON.stringify({
          query: query,
          variables: {
            input: {
              email: email,
              password: password
            }
          }
        });

        fetch('/api/2024-04/graphql.json', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                "Access-Control-Origin": "*",
                "Access-Control-Allow-Origin": "*",
                'X-Shopify-Storefront-Access-Token': "531f5a017c834a6a4e62e97840df6fb7"
            },
            body: requestBody,
        })
        .then((response) => response.json())
        .then((data) => {
          const resultData = data.data.customerAccessTokenCreate;
        
          if(resultData.customerAccessToken == null){
            loginFormElement.submit();
          }else{
            const customerAccessToken = resultData.customerAccessToken.accessToken;
            let expiryCookie = (24*60*60)*7;
            document.cookie = `customerAccessToken=${customerAccessToken}; max-age=${expiryCookie}; path=/account`; 
            loginFormElement.submit();
          }
        });
  }
}

typeof accountPages !== 'undefined' && new accountPages();